import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useT } from "@/i18n/LanguageContext";

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { t } = useT();
  const loc = useLocation();
  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] grid place-items-center text-white/50" data-testid="admin-loading">
        {t.protected?.adminLoading || "Verifying admin session…"}
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (user.role !== "admin" && user.role !== "reviewer") {
    return (
      <div className="mx-auto max-w-2xl px-4 py-24 text-center" data-testid="admin-forbidden">
        <div className="text-6xl">🛑</div>
        <h2 className="mt-4 font-display text-2xl font-extrabold text-white">{t.auth?.adminRequired || "Staff access required"}</h2>
        <p className="mt-2 text-white/60 text-sm">{t.auth?.adminForbiddenDesc || "Your account does not have admin or reviewer privileges."}</p>
      </div>
    );
  }
  return children;
};

export default AdminRoute;
